import React, { useEffect, useRef, useState } from 'react';
import { getData } from '@/services/api.service';
import ProductSection from './productSection';
import HomeSearchBanner from './homeSearchbanner';
import { Link } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveCustomerTab } from '@/core/redux/commonSlice';
import Spinner from './Components/spinner';
import HomePageFooter from './homePageFooter';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdChevronLeft, MdChevronRight, MdClose, MdArrowForward } from 'react-icons/md';
import { theme_5 } from '@/utils/constants';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { routePrefix } from '@/utils/routes/routes';
import HomeThemeFive from './home-5/homeThemeFive';

import { RootState } from '@/core/redux/store';
import HomeThemeOne from './home-1/homeThemeOne';
import HomeThemeTwo from './home-2/homeThemeTwo';
import HomeThemeThree from './home-3/homeThemeThree';
import HomeThemeFour from './home-4/homeThemeFour';

import { setThemeJson } from '@/core/redux/commonSlice';

interface WebsiteSettings {
  id: number;
  enabled: boolean;
  description: string;
  start_date: string;
  end_date: string;
  cta_label: string;
  cta_link: string;
  image: string | null;
  created_at: string;
  updated_at: string;
  images: string[];
}
interface SliderData {
  desktop_img: string;
}

interface Product {
  id: number;
  name: string;
  image: string;
  price: number;
  stock: number;
  link: string;
  [key: string]: any;
}

interface Collection {
  id: number;
  product_category_title?: string | null;
  product_category_type?: string;
  category_slider_title?: string | null;
  product_collection_title?: string | null;
  product_collection_type?: string;
  data: Product[];
}

const HomePage: React.FC = () => {
  const headerData = useSelector((state: RootState) => state.common.header);
  const [themeData, setThemeData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [collections, setCollections] = useState<Collection[]>([]);
  const [homeTheme] = useState(headerData?.template);
  const [websiteSettings, setWebsiteSettings] = useState<WebsiteSettings | null>(null);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  // const [homeTheme] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getData('get_cms_json');
        if (response.status == 200 || response.status == 201) {
          setThemeData(
            response?.data?.data?.cms_json != ''
              ? JSON.parse(response?.data?.data?.cms_json)
              : theme_5
          );
          dispatch(
            setThemeJson(
              response?.data?.data?.cms_json != ''
                ? JSON.parse(response?.data?.data?.cms_json)
                : theme_5
            )
          );
        }

        const collectionsRes = await getData('collections?type=service');
        if (collectionsRes.status === 200 || collectionsRes.status === 201) {
          setCollections(collectionsRes.data.data.widgets);
        }

        const websiteSettingsRes = await getData('website-settings');
        if (websiteSettingsRes.status === 200 || websiteSettingsRes.status === 201) {
          const settings = websiteSettingsRes.data.data.website_settings;
          setWebsiteSettings(settings);
          if (settings.enabled) {
            setShowModal(true);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (homeTheme == '1') {
      import('../assets/css/style1.css');
    } else if (homeTheme == '2') {
      import('../assets/css/style2.css');
    } else if (homeTheme == '3') {
      import('../assets/css/style3.css');
    } else if (homeTheme == '4') {
      import('../assets/css/style4.css');
    } else if (homeTheme == '5') {
      import('../assets/css/style5.css');
    }
  }, []);

  const WebsiteModal = () => {
    if (!showModal || !websiteSettings) return null;

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxImageIndex, setLightboxImageIndex] = useState(0);

    const modalStyles: React.CSSProperties = {
      backgroundColor: '#fff',
      borderRadius: '16px',
      boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      width: '100%',
      maxWidth: '500px',
      maxHeight: '85vh',
      overflowY: 'auto',
      position: 'relative',
    };

    const overlayStyles: React.CSSProperties = {
      position: 'fixed',
      inset: '0',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 50,
      padding: '16px',
    };

    const closeButtonStyles: React.CSSProperties = {
      position: 'absolute',
      top: '12px',
      right: '12px',
      zIndex: 20,
      backgroundColor: '#1f2937',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '32px',
      height: '32px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      transition: 'all 0.2s',
    };

    const imageStyles: React.CSSProperties = {
      width: '200px',
      height: '200px',
      objectFit: 'cover',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'transform 0.2s',
    };

    const navigateImage = (direction: 'prev' | 'next') => {
      if (!websiteSettings.images) return;
      const totalImages = websiteSettings.images.length;
      if (totalImages === 0) return;

      setCurrentImageIndex((prevIndex) => {
        if (direction === 'next') {
          return (prevIndex + 1) % totalImages;
        } else {
          return (prevIndex - 1 + totalImages) % totalImages;
        }
      });
    };

    const navigateLightboxImage = (direction: 'prev' | 'next') => {
      if (!websiteSettings.images) return;
      const totalImages = websiteSettings.images.length;
      if (totalImages === 0) return;

      setLightboxImageIndex((prevIndex) => {
        if (direction === 'next') {
          return (prevIndex + 1) % totalImages;
        } else {
          return (prevIndex - 1 + totalImages) % totalImages;
        }
      });
    };

    const openLightbox = (index: number) => {
      setLightboxImageIndex(index);
      setLightboxOpen(true);
    };

    const closeLightbox = () => {
      setLightboxOpen(false);
    };

    // Lightbox Component
    const Lightbox = () => {
      if (!lightboxOpen || !websiteSettings.images) return null;

      useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
          if (e.key === 'Escape') {
            closeLightbox();
          } else if (e.key === 'ArrowLeft') {
            navigateLightboxImage('prev');
          } else if (e.key === 'ArrowRight') {
            navigateLightboxImage('next');
          }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
      }, []);

      return (
        <div
          style={{
            position: 'fixed',
            inset: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.95)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            padding: '20px',
            animation: 'fadeIn 0.3s ease-in-out',
          }}
          onClick={closeLightbox}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              color: '#000',
              border: 'none',
              borderRadius: '50%',
              width: '44px',
              height: '44px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '24px',
              fontWeight: 'bold',
              zIndex: 10001,
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#fff';
              e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <MdClose size={24} />
          </button>

          {/* Previous Button */}
          {websiteSettings.images.length > 1 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigateLightboxImage('prev');
              }}
              style={{
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                color: '#000',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '28px',
                fontWeight: 'bold',
                zIndex: 10001,
                transition: 'all 0.2s',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              <MdChevronLeft size={32} />
            </button>
          )}

          {/* Image Container */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <div style={{
              maxWidth: '100%',
              maxHeight: 'calc(90vh - 80px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              borderRadius: '8px',
              backgroundColor: '#000',
            }}>
            <img
              src={`http://tharun.webshop.test/images/website/${websiteSettings.images[lightboxImageIndex]}`}
              alt={`Image ${lightboxImageIndex + 1}`}
              style={{
                maxWidth: '100%',
                maxHeight: 'calc(90vh - 80px)',
                objectFit: 'contain',
                borderRadius: '8px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
              }}
            />
            </div>

            {/* Image Counter */}
            <div
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              {lightboxImageIndex + 1} / {websiteSettings.images.length}
            </div>

            {/* Thumbnail Navigation */}
            {websiteSettings.images.length > 1 && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  maxWidth: '600px',
                  padding: '10px',
                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  borderRadius: '12px',
                  zIndex: 1000,
                }}
              >
                {websiteSettings.images.map((image, index) => (
                  <img
                    key={index}
                    src={`http://tharun.webshop.test/images/website/${image}`}
                    alt={`Thumbnail ${index + 1}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLightboxImageIndex(index);
                    }}
                    style={{
                      width: '60px',
                      height: '60px',
                      objectFit: 'cover',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      border: index === lightboxImageIndex ? '3px solid #2563eb' : '3px solid transparent',
                      opacity: index === lightboxImageIndex ? 1 : 0.6,
                      transition: 'all 0.2s',
                    }}
                    onMouseOver={(e) => {
                      if (index !== lightboxImageIndex) {
                        e.currentTarget.style.opacity = '0.9';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (index !== lightboxImageIndex) {
                        e.currentTarget.style.opacity = '0.6';
                      }
                    }}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Next Button */}
          {websiteSettings.images.length > 1 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigateLightboxImage('next');
              }}
              style={{
                position: 'absolute',
                right: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                color: '#000',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '28px',
                fontWeight: 'bold',
                zIndex: 10001,
                transition: 'all 0.2s',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              <MdChevronRight size={32} />
            </button>
          )}
        </div>
      );
    };

    return (
      <>
        <div style={overlayStyles}>
          <div style={modalStyles}>
            <button
              onClick={() => setShowModal(false)}
              style={closeButtonStyles}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#374151';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#1f2937';
              }}
            >
              <MdClose size={18} />
            </button>

            {websiteSettings.images && websiteSettings.images.length > 0 && (
              <div style={{ backgroundColor: '#f0f9ff', padding: '16px', marginBottom: '16px', borderRadius: '8px', position: 'relative' }}>
                {websiteSettings.images.length > 1 && (
                  <button
                    onClick={() => navigateImage('prev')}
                    style={{
                      position: 'absolute',
                      left: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '36px',
                      height: '36px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '18px',
                      zIndex: 10,
                      transition: 'all 0.2s',
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                    }}
                  >
                    <MdChevronLeft size={32} />
                  </button>
                )}

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img
                    src={`http://tharun.webshop.test/images/website/${websiteSettings.images[currentImageIndex]}`}
                    alt={`Website image ${currentImageIndex + 1}`}
                    onClick={() => openLightbox(currentImageIndex)}
                    style={imageStyles}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  />
                </div>
                
                {websiteSettings.images.length > 1 && (
                  <button
                    onClick={() => navigateImage('next')}
                    style={{
                      position: 'absolute',
                      right: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '36px',
                      height: '36px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '18px',
                      zIndex: 10,
                      transition: 'all 0.2s',
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                    }}
                  >
                    <MdChevronRight size={20} />
                  </button>
                )}

                {websiteSettings.images.length > 1 && (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '8px', 
                    marginTop: '12px' 
                  }}>
                    {websiteSettings.images.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentImageIndex(index)}
                        style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          border: 'none',
                          backgroundColor: index === currentImageIndex ? '#2563eb' : '#d1d5db',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
            )}

            <div style={{ marginBottom: '16px' }}>
              <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '8px', textAlign: 'center' }}>
                Announcement
              </h2>
            </div>

            {websiteSettings.description && (
              <div style={{ marginBottom: '16px' }}>
                <div 
                  style={{ color: '#374151e9', lineHeight: '1.5', fontSize: '14px' }}
                  dangerouslySetInnerHTML={{ __html: websiteSettings.description }}
                />
              </div>
            )}

            {websiteSettings.cta_label && websiteSettings.cta_link && (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                
                <a
                  href={websiteSettings.cta_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 24px',
                    backgroundColor: '#2563eb',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '14px',
                    transition: 'all 0.2s',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#1d4ed8';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#2563eb';
                  }}
                >
                  {websiteSettings.cta_label}
                  <MdArrowForward size={16} style={{ marginLeft: '8px' }} />
                </a>
              </div>
            )}
          </div>
        </div>
        <Lightbox />
      </>
    );
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <WebsiteModal />
          {homeTheme == '1' ? (
            <HomeThemeOne themeData={themeData} collections={collections} />
          ) : homeTheme == '2' ? (
            <HomeThemeTwo themeData={themeData} collections={collections} />
          ) : homeTheme == '3' ? (
            <HomeThemeThree themeData={themeData} collections={collections} />
          ) : homeTheme == '4' ? (
            <HomeThemeFour themeData={themeData} collections={collections} />
          ) : homeTheme == '5' ? (
            <HomeThemeFive themeData={themeData} collections={collections} />
          ) : null}
        </>
      )}
    </>
  );
};

export default HomePage;